// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_project_model from "./web_project_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function request(t, body, path, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).project_form !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Project_setup */ 32,
              _0: /* Failed */ 8
            });
            Curry._1(t.failure, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        Curry._1(t.emit, {
          TAG: /* Project_setup */ 32,
          _0: /* Failed */ 8
        });
        Curry._1(t.failure, result._0);
      }
    }
    return Promise.resolve();
  });
}

function next(json) {
  const value = Mapre_wire__Json.get(json, "next_page");
  if (Caml_obj.caml_equal(value, null)) {
    return;
  } else {
    return Mapre_wire__Json.integer(json, "next_page");
  }
}

function accounts(t, workspace, page) {
  Curry._1(t.emit, {
    TAG: /* Project_setup */ 32,
    _0: /* Loading */ 6
  });
  request(t, undefined, "/api/workspaces/" + (workspace + ("/github/installations?page=" + String(page))), (function (json) {
    const rows = Stdlib__List.map((function (row) {
      return {
        id: Mapre_wire__Json.string(row, "id"),
        account: Mapre_wire__Json.string(row, "account")
      };
    }), Stdlib__Array.to_list(Mapre_wire__Json.array(json, "installations")));
    const action_1 = next(json);
    const action_2 = Mapre_wire__Json.string(json, "install_url");
    const action = {
      TAG: /* Accounts_loaded */ 2,
      _0: rows,
      _1: action_1,
      _2: action_2
    };
    Curry._1(t.emit, {
      TAG: /* Project_setup */ 32,
      _0: action
    });
  }));
}

function repositories(t, workspace, account, page) {
  Curry._1(t.emit, {
    TAG: /* Project_setup */ 32,
    _0: /* Loading */ 6
  });
  request(t, undefined, "/api/workspaces/" + (workspace + ("/github/installations/" + (account.id + ("/repositories?page=" + String(page))))), (function (json) {
    const rows = Stdlib__List.map((function (row) {
      return {
        id: Mapre_wire__Json.string(row, "id"),
        full_name: Mapre_wire__Json.string(row, "full_name")
      };
    }), Stdlib__Array.to_list(Mapre_wire__Json.array(json, "repositories")));
    const action_1 = next(json);
    const action = {
      TAG: /* Repositories_loaded */ 4,
      _0: rows,
      _1: action_1
    };
    Curry._1(t.emit, {
      TAG: /* Project_setup */ 32,
      _0: action
    });
  }));
}

function dispatch(t, action) {
  const model = Curry._1(t.model, undefined);
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Close */ 0) {
      cancel(t);
      return Curry._1(t.emit, {
        TAG: /* Project_setup */ 32,
        _0: /* Close */ 0
      });
    }
    
  } else {
    switch (action.TAG) {
      case /* Open */ 0 :
        if (Mapre_web__Web_model.can_manage_project(model)) {
          return Stdlib__Option.iter((function (workspace) {
            cancel(t);
            const action = {
              TAG: /* Open */ 0,
              _0: crypto.randomUUID()
            };
            Curry._1(t.emit, {
              TAG: /* Project_setup */ 32,
              _0: action
            });
            accounts(t, workspace, 1);
          }), Mapre_web__Web_types.workspace(model.route));
        }
        break;
      case /* Rebind */ 1 :
        if (Mapre_web__Web_model.can_manage_project(model) && Mapre_web__Web_model.can_edit_environment(model)) {
          return Stdlib__Option.iter((function (workspace) {
            cancel(t);
            const action = {
              TAG: /* Rebind */ 1,
              _0: crypto.randomUUID()
            };
            Curry._1(t.emit, {
              TAG: /* Project_setup */ 32,
              _0: action
            });
            accounts(t, workspace, 1);
          }), Mapre_web__Web_types.workspace(model.route));
        }
        break;
    }
  }
  if (!Mapre_web__Web_model.can_manage_project(model)) {
    return;
  }
  const match = Mapre_web__Web_types.workspace(model.route);
  const match$1 = model.project_form;
  if (match !== undefined && match$1 !== undefined && !match$1.pending) {
    if (/* tag */ typeof action !== "object" && typeof action !== "function") {
      switch (action) {
        case /* Refresh */ 1 :
          cancel(t);
          return accounts(t, match, 1);
        case /* More_accounts */ 2 :
          return Stdlib__Option.iter((function (param) {
            return accounts(t, match, param);
          }), match$1.account_page);
        case /* More_repositories */ 3 :
          return Stdlib__Option.iter((function (account) {
            Stdlib__Option.iter((function (param) {
              return repositories(t, match, account, param);
            }), match$1.repository_page);
          }), match$1.account);
        case /* Back */ 4 :
          cancel(t);
          return Curry._1(t.emit, {
            TAG: /* Project_setup */ 32,
            _0: action
          });
        case /* Connect */ 5 :
          const match$2 = match$1.account;
          const match$3 = match$1.repository;
          if (match$2 === undefined) {
            return;
          }
          if (match$3 === undefined) {
            return;
          }
          if (!Mapre_web__Web_project_model.can_connect(match$1)) {
            return;
          }
          Curry._1(t.emit, {
            TAG: /* Project_setup */ 32,
            _0: /* Pending */ 7
          });
          const target = match$1.target;
          const match$4 = target !== undefined ? [
              "/" + (target.project_id + "/repository"),
              {
                hd: [
                  "expected_version",
                  target.version
                ],
                tl: /* [] */ 0
              }
            ] : [
              "",
              {
                hd: [
                  "name",
                  Mapre_wire__Json.str(match$1.name)
                ],
                tl: /* [] */ 0
              }
            ];
          const body = JSON.stringify(Js__Js_dict.fromList(Stdlib.$at(match$4[1], Stdlib.$at(match$1.branch === "" ? /* [] */ 0 : ({
              hd: [
                "base_branch",
                Mapre_wire__Json.str(match$1.branch)
              ],
              tl: /* [] */ 0
            }), {
            hd: [
              "request_id",
              Mapre_wire__Json.str(match$1.request_id)
            ],
            tl: {
              hd: [
                "installation_id",
                Mapre_wire__Json.str(match$2.id)
              ],
              tl: {
                hd: [
                  "repository_full_name",
                  Mapre_wire__Json.str(match$3.full_name)
                ],
                tl: /* [] */ 0
              }
            }
          }))));
          return request(t, body, "/api/workspaces/" + (match + ("/projects" + match$4[0])), (function (json) {
            const id = Mapre_wire__Json.string(Mapre_wire__Json.get(json, "project"), "id");
            Curry._1(t.navigate, match$1.target === undefined ? ({
                TAG: /* Project */ 2,
                _0: match,
                _1: id
              }) : Curry._1(t.model, undefined).route);
          }));
        default:
          return Curry._1(t.emit, {
            TAG: /* Project_setup */ 32,
            _0: action
          });
      }
    } else {
      switch (action.TAG) {
        case /* Choose_account */ 3 :
          cancel(t);
          Curry._1(t.emit, {
            TAG: /* Project_setup */ 32,
            _0: action
          });
          return repositories(t, match, action._0, 1);
        case /* Choose_repository */ 5 :
          const action_0 = action._0;
          const action_1 = crypto.randomUUID();
          const action$1 = {
            TAG: /* Repository_selected */ 6,
            _0: action_0,
            _1: action_1
          };
          return Curry._1(t.emit, {
            TAG: /* Project_setup */ 32,
            _0: action$1
          });
        default:
          return Curry._1(t.emit, {
            TAG: /* Project_setup */ 32,
            _0: action
          });
      }
    }
  }
  
}

function create(emit, model, failure, navigate) {
  return {
    emit,
    model,
    failure,
    navigate,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
